import { mount } from 'svelte';
let app = {};


/* NON RES */
/* MULTI DIRECT DEBIT PAGE 1 */
let multiDDContainer = document.getElementById("Form.direct-debit-multiple")
if (multiDDContainer) {
  import("./non_residential/payments/pages/MultiDirectDebit.svelte").then(
    ({ default: MultiDirectDebit }) => {
      let { checked, deletedirectdebiturl, showpayregular } = multiDDContainer.dataset;
      multiDDContainer.innerHTML = "";
      app.multidd = mount(MultiDirectDebit,{
        target: multiDDContainer,
        props: {
          selectedRadio: checked,
          deleteDirectDebitUrl: deletedirectdebiturl,
          showPayRegular: showpayregular
        }
      })
    }
  )
}

/* account number input */
let accountBalanceInputContainers = document.querySelectorAll("div[id^='make-payment-account']")
if (accountBalanceInputContainers && accountBalanceInputContainers.length) {
  import("./my_account/components/AccountNumber.svelte").then(
    ({ default: AccountNumber }) => {
      for (let index = 0; index < accountBalanceInputContainers.length; index++) {
        const element = accountBalanceInputContainers[index];
        const input = element.querySelector(".input-primary");
        const { name, value, id } = input;
        if (name && id && element) {
          element.innerHTML = "";
          app[`accountBalanceInput-${index}`] = mount(AccountNumber, {
            target: element,
            props: {
              id,
              name,
              value,
            },
          });
        }
      }
    }
  );
}

/* Payment List item logged out */
let make_payment_not_loggedin = document.querySelector("#MakePaymentNotLoggedIn");
if (make_payment_not_loggedin) {
  let { properties, selected, surchargetext } = make_payment_not_loggedin.dataset;
  if (properties) {
    import("./non_residential/payments/pages/MakePaymentNotLoggedIn.svelte").then(
      ({ default: MakePaymentNotLoggedIn }) => {
        make_payment_not_loggedin.innerHTML = "";
        app.make_payment_not_loggedin = mount(MakePaymentNotLoggedIn, {
          target: make_payment_not_loggedin,
          props: {
            property_list: JSON.parse(properties),
            selected_property: selected,
            surcharge_text: surchargetext
          }
        });
      }
    );
  }
}

/* Payment List item logged in*/
let make_payment_loggedin = document.querySelector("#MakePaymentLoggedIn");
if (make_payment_loggedin) {
  let { properties, selectedproperties, overdue, surchargetext, firstload } = make_payment_loggedin.dataset;
  if (properties) {
    import("./non_residential/payments/pages/MakePaymentLoggedIn.svelte").then(
      ({ default: MakePaymentLoggedIn }) => {
        make_payment_loggedin.innerHTML = "";
        app.make_payment_loggedin = mount(MakePaymentLoggedIn, {
          target: make_payment_loggedin,
          props: {
            property_list: properties ? JSON.parse(properties) : [],
            due_url: overdue,
            selected_properties: selectedproperties ? JSON.parse(selectedproperties) : [],
            surcharge_text: surchargetext,
            firstLoad: firstload
          }
        });
      }
    );
  }
}



/* WaterSourcesGraph */
let watersources_graph_container = document.querySelector("#waterSourcesGraph");
if (watersources_graph_container) {
  import("./climate_change/WaterSourcesGraph.svelte").then(
    ({ default: WaterSourcesGraph }) => {
      watersources_graph_container.innerHTML = "";
      app.watersources_graph = mount(WaterSourcesGraph, {
        target: watersources_graph_container,
        props: {
          api_endpoint: watersources_graph_container.dataset.endpoint
        }
      });
    }
  );
}

let credit_card_container = document.getElementById(
  "credit_card_container"
);

if (credit_card_container) {
  import("./credit_card/CreditCard.svelte").then(
    ({ default: CreditCard }) => {
      credit_card_container.innerHTML = ""
      app.credit_card = mount(CreditCard, {
        target: credit_card_container,
        props: {
          formName: credit_card_container.dataset.form,
          mediaURL: credit_card_container.dataset.media,
          amexCallback: credit_card_container.dataset.amexcallback
        }
      });
    })
}

/* Article Filter */
let article_filter_container = document.getElementById(
  "article_filter_container"
);
let stories = document.getElementById("article_filter_default");
if (article_filter_container && stories) {
  import("./articles/ArticlesFilter.svelte").then(
    ({ default: ArticlesFilter }) => {
      let existing_container = stories.cloneNode(true);
      stories.remove();
      article_filter_container.innerHTML = "";
      app.article_filter = mount(ArticlesFilter, {
        target: article_filter_container,
        props: {
          article_api_endpoint: article_filter_container.dataset.endpoint,
          existing_container
        },
      });
    }
  );
}

/* AutocompleteForm */
let autocompleteForm = document.querySelectorAll(".wc-auto__form");
if (autocompleteForm) {
  import("./autocomplete/AutocompleteForm.svelte").then(
    ({ default: AutocompleteForm }) => {
      for (let index = 0; index < autocompleteForm.length; index++) {
        let afcForm = autocompleteForm[index];
        let afcDs = afcForm.dataset;
        afcForm.innerHTML = "";
        app[`autocompleteForm${index}`] = mount(AutocompleteForm, {
          target: afcForm,
          props: {
            id: afcDs.id || `SearchTerm${index}`,
            name: afcDs.name || `SearchTerm${index}`,
            placeholder: afcDs.placeholder || "Ask a question or enter a topic",
            url: afcDs.url || "/api/sitecore/SearchSuggestions/Suggestions",
            className: afcDs.classname || "wc-page-search__input",
            formClass: afcDs.formclassname || "wc-page-search",
            formAction: afcDs.formaction || "/Help-and-advice/Search-Result",
            hiddenName: afcDs.hidden || "Filters[category_facet]",
            hiddenValue: afcDs.hiddenvalue || undefined,
            submitValue: afcDs.submit || "Search",
            accessibleLabel: afcDs.accessible || "Article search",
            isTop: afcDs.top === "true",
          },
        });
      }
    }
  );
}

/* Alert */
let alertIds = document.querySelectorAll(".alertsvelte");
alertIds.forEach(alertId => {
  if (alertId) {
    import("./alerts/Alert.svelte").then(({ default: Alert }) => {
      alertId.innerHTML = "";
      app.alert = mount(Alert, {
        target: alertId,
        props: {
          message: alertId.dataset.message,
          logo: alertId.dataset.logo,
        },
      });
    });
  }
})


/* Pagination */
let paginateDiv = document.getElementById("Paginate");
if (paginateDiv) {
  import("./paginate/Paginate.svelte").then(({ default: Paginate }) => {
    app.paginate = mount(Paginate, {
      target: paginateDiv,
    });
  });
}

/* Waterwise */
let waterwise_app = document.querySelector("#waterwise-specialists-categories");
if (waterwise_app) {
  function getParameterByName(name) {
    let url = window.location.href;
    let regname = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + regname + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function checkIsBackflow() {
    let pathname = window.location.pathname;
    return pathname.indexOf("backflow") !== -1;
  }

  let { categories, plumberfeatures } = waterwise_app.dataset;
  let isBackflow = checkIsBackflow();
  let value = isBackflow ? "plumbers" : getParameterByName("radio");
  let checkbox = isBackflow
    ? "backflowprevention"
    : getParameterByName("checkbox");
  import("./water_wise/WaterwiseCategories.svelte").then(
    ({ default: WaterwiseCategories }) => {
      waterwise_app.innerHTML = "";
      app.water_wise = mount(WaterwiseCategories, {
        target: waterwise_app,
        props: {
          categories,
          plumberfeatures,
          value,
          checkbox,
        },
      });
    }
  );
}

/* Waterwise Products */
let waterwiseProducts_app = document.querySelector("#waterwise-products-cards");
if (waterwiseProducts_app) {
  function getParameterByName(name) {
    let url = window.location.href;
    let regname = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + regname + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  let categories = waterwiseProducts_app.dataset.categories;
  let anchorText = waterwiseProducts_app.dataset.anchortext;
  let checkedProduct = getParameterByName("radio");

  import("./water_wise/WaterwiseProducts.svelte").then(
    ({ default: WaterwiseProducts }) => {
      waterwiseProducts_app.innerHTML = "";
      app.water_wiseProducts = mount(WaterwiseProducts, {
        target: waterwiseProducts_app,
        props: {
          categories,
          checkedProduct,
          anchorText
        },
      });
    }
  );
}

// Waterwise needs improvement
let needs_improvement_app = document.querySelector(
  "#waterwise-needs-improvement"
);
let needsImprovementApp = null;
if (needs_improvement_app) {
  import("./water_wise/NeedsImprovement.svelte").then(
    ({ default: NeedsImprovement }) => {
      needs_improvement_app.innerHTML = "";
      needsImprovementApp = mount(NeedsImprovement, {
        target: needs_improvement_app,
        props: {
          status: needs_improvement_app.dataset.status,
        },
      });
    }
  );
}

/* Water supply */
let watering_days_app = document.querySelector("#wateringdays-app");
if (watering_days_app) {
  let {
    wateringdaysapi,
    winterbanapi,
    winterbanstartdate,
    winterbanenddate,
    winterbanpageurl,
    wateringdayspageurl,
    findoutwhyurl,
  } = watering_days_app.dataset;
  import("./water_supply/WateringDays.svelte").then(
    ({ default: WateringDays }) => {
      watering_days_app.innerHTML = "";
      app.water_supply = mount(WateringDays, {
        target: watering_days_app,
        props: {
          wateringDaysApi: wateringdaysapi,
          winterBanApi: winterbanapi,
          winterBanStartDate: winterbanstartdate,
          winterBanEndDate: winterbanenddate,
          winterBanPageUrl: winterbanpageurl,
          wateringDaysPageUrl: wateringdayspageurl,
          findOutWhyUrl: findoutwhyurl,
        },
      });
    }
  );
}

/* Countdown duration */
let countdownDuration = document.querySelector("#countdown_duration");
let day = "0";
let hour = "0";
if (countdownDuration) {
  if ("day" in countdownDuration.dataset) {
    day = countdownDuration.dataset.day;
  } else {
    day = "0";
  }
  if ("hour" in countdownDuration.dataset) {
    hour = countdownDuration.dataset.hour;
  } else {
    hour = "0";
  }
  import("./water_supply/CountDownDuration.svelte").then(({ default: CountDownDuration }) => {
    countdownDuration.innerHTML = "";
    app.countdown_duration = mount(CountDownDuration, {
      target: countdownDuration,
      props: {
        day,
        hour
      },
    });
  });
}

/* Outages */
let localOutagesDiv = document.querySelector("#local-outage");
if (localOutagesDiv) {
  let url = null;
  if ("url" in localOutagesDiv.dataset) {
    url = localOutagesDiv.dataset.url;
  } else {
    url = "/api/outages/local";
  }
  import("./outages/LocalOutages.svelte").then(({ default: LocalOutages }) => {
    localOutagesDiv.innerHTML = "";
    app.local_outages = mount(LocalOutages, {
      target: localOutagesDiv,
      props: {
        url,
      },
    });
  });
}

/* Ongoing works */
let OngoingWorksId = document.querySelector("#ongoingWorks");
if (OngoingWorksId) {
  import("./ongoing_works/pages/OngoingWorks.svelte").then(
    ({ default: OngoingWorks }) => {
      OngoingWorksId.innerHTML = "";
      app.ongoing_works = mount(OngoingWorks, {
        target: OngoingWorksId,
        props: {
          url: OngoingWorksId.getAttribute("data-url"),
        },
      });
    }
  );
}

/* My account */
let cdn_container = document.getElementById("content");
let homeId = document.getElementById("home-type");
let occupancyId = document.getElementById("occupancy");
let sourcesId = document.getElementById("sources");
let appliancesId = document.getElementById("appliances");
let gardenId = document.getElementById("garden");
let fixturesId = document.getElementById("fixtures");
let savingId = document.getElementById("saving");
let removeAccountById = document.getElementById("account-select-container");
let DDById = document.getElementById("Form.direct-debit");
let DDConfirmById = document.getElementById("Form.direct-debit-confirm");
let UpdateCCExpiryById = document.getElementById("Form.update-expiry-date");
let bankOrCardId = document.getElementById("Form.direct-debit-type");
let propertySelectId = document.querySelector(".property-select-svelte");
let DDpropertySelectContainer = document.getElementById(
  "Form.select-account-container"
);
let waterwiseStatusDiv = document.querySelector("#waterwise-status");
let accountBalanceDiv = document.getElementById("account-balance__input");
let waterBalanceDiv = document.getElementById("watercompare__input");
let makePaymentDiv = document.getElementById("make-payment__input");

// Home
if (homeId) {
  import("./my_account/pages/Home.svelte").then(({ default: Home }) => {
    homeId.innerHTML = "";
    app.home = mount(Home, {
      target: homeId,
      props: {
        checked: homeId.getAttribute("data-checked"),
        size: homeId.getAttribute("data-size"),
      },
    });
  });
}

// Occupants
if (occupancyId) {
  import("./my_account/pages/Occupants.svelte").then(
    ({ default: Occupants }) => {
      occupancyId.innerHTML = "";
      app.occupants = mount(Occupants, {
        target: occupancyId,
        props: {
          adults: Number(occupancyId.getAttribute("data-adults")),
          teenagers: Number(occupancyId.getAttribute("data-teenagers")),
          children: Number(occupancyId.getAttribute("data-children")),
          infants: Number(occupancyId.getAttribute("data-infants")),
        },
      });
    }
  );
}

// Sources
if (sourcesId) {
  import("./my_account/pages/Sources.svelte").then(({ default: Sources }) => {
    sourcesId.innerHTML = "";
    app.sources = mount(Sources, {
      target: sourcesId,
      props: {
        toilets: Number(sourcesId.getAttribute("data-toilets")),
        showers: Number(sourcesId.getAttribute("data-showers")),
        baths: Number(sourcesId.getAttribute("data-baths")),
        bathroomsinks: Number(sourcesId.getAttribute("data-bathroomsinks")),
        kitchensinks: Number(sourcesId.getAttribute("data-kitchensinks")),
        laundrysinks: Number(sourcesId.getAttribute("data-laundrysinks")),
        outsidetaps: Number(sourcesId.getAttribute("data-outsidetaps")),
      },
    });
  });
}

// Appliances
if (appliancesId) {
  import("./my_account/pages/Appliances.svelte").then(
    ({ default: Appliances }) => {
      appliancesId.innerHTML = "";
      app.appliances = mount(Appliances, {
        target: appliancesId,
        props: {
          checked: appliancesId.getAttribute("data-checked"),
        },
      });
    }
  );
}

// Garden
if (gardenId) {
  import("./my_account/pages/Garden.svelte").then(({ default: Garden }) => {
    gardenId.innerHTML = "";
    app.garden = mount(Garden, {
      target: gardenId,
      props: {
        checked: gardenId.getAttribute("data-checked"),
      },
    });
  });
}

// Fixtures
if (fixturesId) {
  import("./my_account/pages/Fixtures.svelte").then(({ default: Fixtures }) => {
    fixturesId.innerHTML = "";
    app.fixtures = mount(Fixtures, {
      target: fixturesId,
      props: {
        checked: fixturesId.getAttribute("data-checked"),
      },
    });
  });
}

// Saving
if (savingId) {
  import("./my_account/pages/Saving.svelte").then(({ default: Saving }) => {
    savingId.innerHTML = "";
    app.saving = mount(Saving, {
      target: savingId,
      props: {
        checked: savingId.getAttribute("data-checked"),
      },
    });
  });
}

// AccountNumber
if (accountBalanceDiv) {
  import("./my_account/components/AccountNumber.svelte").then(
    ({ default: AccountNumber }) => {
      accountBalanceDiv.innerHTML = "";
      app.account_number = mount(AccountNumber, {
        target: accountBalanceDiv,
        props: {
          name: "accountNo",
          value: accountBalanceDiv.dataset.value,
        },
      });
    }
  );
}

// AccountNumber
if (waterBalanceDiv) {
  import("./my_account/components/AccountNumber.svelte").then(
    ({ default: AccountNumber }) => {
      waterBalanceDiv.innerHTML = "";
      app.account_number = mount(AccountNumber, {
        target: waterBalanceDiv,
        props: {
          name: "AccountNum",
          value: waterBalanceDiv.dataset.value,
        },
      });
    }
  );
}

// AccountNumber
if (makePaymentDiv) {
  import("./my_account/components/AccountNumber.svelte").then(
    ({ default: AccountNumber }) => {
      makePaymentDiv.innerHTML = "";
      app.account_number = mount(AccountNumber, {
        target: makePaymentDiv,
        props: {
          name: "Form.AccountNo",
          value: makePaymentDiv.dataset.value,
        },
      });
    }
  );
}

// Property Select
if (propertySelectId) {
  import("./my_account/components/PropertySelect.svelte").then(
    ({ default: PropertySelect }) => {

      let valueElement = propertySelectId.querySelector(
        ".property-select-input"
      );
      let targetElement = propertySelectId.querySelector(
        ".property-select-target"
      );

      if (targetElement) {
        let dataList = targetElement.dataset.properties
          ? JSON.parse(targetElement.dataset.properties)
          : [];
        let addAddressUrl = targetElement.dataset.addaccountlink;
        let removeAddressUrl = targetElement.dataset.removeaccountlink;
        targetElement.innerHTML = ""
        app.property_select = mount(PropertySelect, {
          target: targetElement,
          props: {
            valueElement,
            addAddressUrl,
            removeAddressUrl,
            dataList,
            containerElement: propertySelectId,
          },
        });
      }
    }
  );
}

// RemoveAccount
if (removeAccountById) {
  let removeParent = removeAccountById.getElementsByTagName("input")[0];
  if (removeParent) {
    import("./my_account/pages/RemoveAccount.svelte").then(
      ({ default: RemoveAccount }) => {
        removeAccountById.innerHTML = "";
        app.remove_account = mount(RemoveAccount, {
          target: removeAccountById,
          props: {
            parent: removeParent,
          },
        });
      }
    );
  }
}

// DD
if (DDById) {
  import("./my_account/pages/DD.svelte").then(({ default: DD }) => {
    let DDParent = document.querySelector("#SelectedPropertyAccount");
    DDById.innerHTML = "";
    const {
      checked,
      loggedin,
      form,
      list,
      enablemultiple,
      multiple,
      previous,
      deletedirectdebiturl,
    } = DDParent.dataset;

    app.direct_debit = mount(DD, {
      target: DDById,
      props: {
        parent: DDParent,
        checked: checked === "PayInFullAmount" || checked === "PayInSmallAmounts",
        loggedin,
        form,
        dataList: list ? JSON.parse(list) : [],
        enablemultiple: (enablemultiple || "False").toLowerCase() === "true",
        previous: (previous || "False").toLowerCase() === "true",
        multiple: (multiple || "False").toLowerCase() === "true",
        deletedirectdebiturl: deletedirectdebiturl ?? "",
        containerElement: DDpropertySelectContainer,
        cdnUrl: cdn_container && cdn_container.dataset.cdn,
        version: cdn_container && cdn_container.dataset.version,
      },
    });
  });
}

// DDConfirm
if (DDConfirmById) {
  import("./my_account/pages/DDConfirm.svelte").then(
    ({ default: DDConfirm }) => {
      let DDConfirmParent = document.querySelector("#DebitConfirmed");
      DDConfirmById.innerHTML = "";
      app.direct_debit_confirm = mount(DDConfirm, {
        target: DDConfirmById,
        props: {
          parent: DDConfirmParent,
        },
      });
    }
  );
}

// Update CC Expiry
if (UpdateCCExpiryById) {
  import("./my_account/pages/UpdateCCExpiry.svelte").then(({ default: UpdateCCExpiry }) => {
    let selectorParent = document.querySelector("#SelectedPropertyAccount");
    let updateCCExpiryForm = document.getElementById("expiryDateForm");
    UpdateCCExpiryById.innerHTML = "";
    app.update_cc_expiry = new UpdateCCExpiry({
      target: UpdateCCExpiryById,
      props: {
        parent: selectorParent,
        containerElement: updateCCExpiryForm,
      },
    });
  });
}

// BankOrCard
if (bankOrCardId) {
  import("./my_account/pages/BankOrCard.svelte").then(
    ({ default: BankOrCard }) => {
      let BankOrCardParent = document.querySelector("#DebitType");

      bankOrCardId.innerHTML = "";
      app.bank_or_card = mount(BankOrCard, {
        target: bankOrCardId,
        props: {
          parent: BankOrCardParent,
        },
      });
    }
  );
}

// WaterwiseStatus
if (waterwiseStatusDiv) {
  import("./my_account/pages/WaterwiseStatus.svelte").then(
    ({ default: WaterwiseStatus }) => {
      let url = null;
      let link = null;
      if ("url" in waterwiseStatusDiv.dataset) {
        url = waterwiseStatusDiv.dataset.url;
      } else {
        url = "/api/ww/status";
      }
      if ("link" in waterwiseStatusDiv.dataset) {
        link = waterwiseStatusDiv.dataset.link;
      }
      waterwiseStatusDiv.innerHTML = "";
      app.waterwise_status = mount(WaterwiseStatus, {
        target: waterwiseStatusDiv,
        props: {
          url,
          link,
        },
      });
    }
  );
}

/** Dams and rainfall */
// Dam Levels
let propsDiv = document.querySelectorAll(".wc-dam-total-cap-data");
if (propsDiv && propsDiv.length) {
  import("./dams_and_rainfall/dam-capacity/DamCapacity.svelte").then(
    ({ default: DamCapacity }) => {
      [...propsDiv].forEach((display) => {
        let id = display.getAttribute("data-div");
        let el = document.querySelector(`#${id}`);
        if (id && el) {
          el.innerHTML = "";
          app[id] = mount(DamCapacity, {
            target: el,
            props: {
              url: display.getAttribute("data-url"),
              damID: display.getAttribute("data-dam"),
              parent: el,
            },
          });
        }
      });
    }
  );
}

// Dams and rainfall overview
let dashDiv = document.querySelector("#wc-our-water-sources");
if (dashDiv) {
  import("./dams_and_rainfall/dashboard/Dashboard.svelte").then(
    ({ default: Dashboard }) => {
      dashDiv.innerHTML = "";
      app.dam_dash = mount(Dashboard, {
        target: dashDiv,
        props: {
          data: {
            damprcnt: Number(dashDiv.getAttribute("data-damprcnt")),
            damgl: Number(dashDiv.getAttribute("data-damgl")),
            damlast: Number(dashDiv.getAttribute("data-damlast")),
            damlastgl: Number(dashDiv.getAttribute("data-damlastgl")),
            change: Number(dashDiv.getAttribute("data-change")),
            changegl: Number(dashDiv.getAttribute("data-changegl")),
            total: Number(dashDiv.getAttribute("data-total")),
            average: Number(dashDiv.getAttribute("data-average")),
            rain: Number(dashDiv.getAttribute("data-rain")),
            streamflow: Number(dashDiv.getAttribute("data-streamflow")),
            streamflowMonth: dashDiv.getAttribute("data-streamflowmonth"),
            use: Number(dashDiv.getAttribute("data-use")),
            month: dashDiv.getAttribute("data-month"),
            damurl: dashDiv.getAttribute("data-damurl"),
            rainurl: dashDiv.getAttribute("data-rainurl"),
            streamurl: dashDiv.getAttribute("data-streamurl"),
            useurl: dashDiv.getAttribute("data-useurl"),
            labelDam: dashDiv.getAttribute("data-labeldam"),
            labelRegion: dashDiv.getAttribute("data-labelregion"),
            isDamsPage: dashDiv.getAttribute("data-isDamsPage"),
            isRainfallPage: dashDiv.getAttribute("data-isRainfallPage"),
            isStreamflowPage: dashDiv.getAttribute("data-isStreamflowPage"),
            isWaterUsePage: dashDiv.getAttribute("data-isWaterUsePage"),
          }
        }
      });
    }
  );
}

// Homepage dams overview
let overviewDiv = document.querySelector("#wc-dash");
if (overviewDiv) {
  import("./dams_and_rainfall/overview/Overview.svelte").then(
    ({ default: Overview }) => {
      overviewDiv.innerHTML = "";
      app.dam_overview = mount(Overview, {
        target: overviewDiv
      });
    }
  );
}

// Homepage streamflow overview
let streamflowOverviewDiv = document.querySelector("#wc-streamflow-dash");
if (streamflowOverviewDiv) {
  import("./dams_and_rainfall/overview/StreamflowOverview.svelte").then(
    ({ default: StreamflowOverview }) => {
      const { month, year, monthdata, historicalmonthdata, diffvalue, diffpercentage, maxstreamflow, content, ctalink, title } = streamflowOverviewDiv.dataset;
      streamflowOverviewDiv.innerHTML = "";
      app.streamflow_overview = mount(StreamflowOverview, {
        target: streamflowOverviewDiv,
        props: { month, year, monthdata, historicalmonthdata, diffvalue, diffpercentage, maxstreamflow, content, ctalink, title }
      });
    }
  );
}

/* Concession */
let removeSpacesFromInputsDivs = document.querySelectorAll(".wc-concessions-clean-inputs");
if (removeSpacesFromInputsDivs) {
  for (let i = 0; i < removeSpacesFromInputsDivs.length; i++) {
    import("./forms/concession/RemoveSpacesFromInputs.svelte").then(
      ({ default: RemoveSpacesFromInputs }) => {
        app[`clean_concession_form_${i}`] = mount(RemoveSpacesFromInputs, {
          target: removeSpacesFromInputsDivs[i],
          props: {
            select: removeSpacesFromInputsDivs[i]
          },
        });
      }
    );
  }
}

let showHideDivs = document.querySelectorAll(".wc-toggle");
if (showHideDivs) {
  for (let i = 0; i < showHideDivs.length; i++) {
    let parent = showHideDivs[i].parentElement;
    let type = showHideDivs[i].dataset.type;
    let noofowners = showHideDivs[i].dataset.noofownersid;

    if (type === "radio") {
      import("./forms/concession/YesNoShow.svelte").then(
        ({ default: YesNoShow }) => {
          let name = showHideDivs[i].dataset.name;
          let legend = showHideDivs[i].dataset.legend;
          let extraText = showHideDivs[i].dataset.extratext;
          let noRadioID = showHideDivs[i].dataset.noradioid;
          let yesRadioID = showHideDivs[i].dataset.yesradioid;
          let noRadioText = showHideDivs[i].dataset.noradiotext;
          let yesRadioText = showHideDivs[i].dataset.yesradiotext;
          let radioClass = showHideDivs[i].dataset.radioclass;
          let defaultChecked = showHideDivs[i].dataset.defaultchecked;
          let backupHiddenFieldId = showHideDivs[i].dataset.backuphiddenfieldid;
          showHideDivs[i].innerHTML = "";
          app[`concession_form_${i}`] = mount(YesNoShow, {
            target: showHideDivs[i],
            props: {
              parent,
              name,
              legend,
              extraText,
              noRadioID,
              yesRadioID,
              noRadioText,
              yesRadioText,
              radioClass,
              defaultChecked,
              backupHiddenFieldId
            },
          });
        }
      );
    }

    if (type === "radioselect") {
      import("./forms/concession/YesNoSelect.svelte").then(
        ({ default: YesNoSelect }) => {
          let name = showHideDivs[i].dataset.name;
          let legend = showHideDivs[i].dataset.legend;
          let extraText = showHideDivs[i].dataset.extratext;
          let noRadioID = showHideDivs[i].dataset.noradioid;
          let yesRadioID = showHideDivs[i].dataset.yesradioid;
          let noRadioText = showHideDivs[i].dataset.noradiotext;
          let yesRadioText = showHideDivs[i].dataset.yesradiotext;
          let radioClass = showHideDivs[i].dataset.radioclass;
          let defaultChecked = showHideDivs[i].dataset.defaultchecked;
          let backupHiddenFieldId = showHideDivs[i].dataset.backuphiddenfieldid;
          showHideDivs[i].innerHTML = "";
          app[`concession_form_${i}`] = mount(YesNoSelect, {
            target: showHideDivs[i],
            props: {
              parent,
              name,
              legend,
              extraText,
              noRadioID,
              yesRadioID,
              noRadioText,
              yesRadioText,
              radioClass,
              defaultChecked,
              backupHiddenFieldId
            },
          });
        }
      );
    }

    if (type === "select") {
      import("./forms/concession/SelectToggle.svelte").then(
        ({ default: SelectToggle }) => {
          app[`concession_form_${i}`] = mount(SelectToggle, {
            target: showHideDivs[i],
            props: {
              select: showHideDivs[i],
            },
          });
        }
      );
    }

    if (type === "specificselect") {
      import("./forms/concession/SpecificSelect.svelte").then(
        ({ default: SpecificSelect }) => {
          app[`concession_form_${i}`] = mount(SpecificSelect, {
            target: showHideDivs[i],
            props: {
              select: showHideDivs[i],
            },
          });
        }
      );
    }

    if (type === "reversespecificselect") {
      import("./forms/concession/ReverseSpecificSelect.svelte").then(
        ({ default: ReverseSpecificSelect }) => {
          app[`concession_form_${i}`] = mount(ReverseSpecificSelect, {
            target: showHideDivs[i],
            props: {
              select: showHideDivs[i],
            },
          });
        }
      );
    }

    if (type === "specialselect") {
      import("./forms/concession/SpecialSelect.svelte").then(
        ({ default: SpecialSelect }) => {
          app[`concession_form_${i}`] = mount(SpecialSelect, {
            target: showHideDivs[i],
            props: {
              select: showHideDivs[i],
              noofowners: noofowners
            },
          });
        }
      );
    }

    if (type === "checkbox") {
      import("./forms/concession/CheckboxToggle.svelte").then(
        ({ default: CheckboxToggle }) => {
          app[`concession_form_${i}`] = mount(CheckboxToggle, {
            target: showHideDivs[i],
            props: {
              checkboxGroup: showHideDivs[i],
            },
          });
        }
      );
    }

    if (type === "checkbox-enable") {
      let checkboxElements = showHideDivs[i].querySelectorAll(
        'input[type="checkbox"]'
      );
      let checkboxes = Array.from(checkboxElements);
      if (checkboxElements) {
        import("./forms/concession/CheckMultipleToEnable.svelte").then(
          ({ default: CheckMultipleToEnable }) => {
            app[`concession_form_${i}`] = mount(CheckMultipleToEnable, {
              target: showHideDivs[i],
              props: {
                checkboxes,
              },
            });
          }
        );
      }
    }
  }
}

let checkToEnable = document.querySelector("#AcceptDeclaration");
if (checkToEnable) {
  import("./forms/concession/CheckToEnable.svelte").then(
    ({ default: CheckToEnable }) => {
      app.concession_form_declaration = mount(CheckToEnable, {
        target: checkToEnable,
        props: {
          checkbox: checkToEnable,
        },
      });
    }
  );
}


window.loadDatePickers = () => {
  let datepickerInputs = document.querySelectorAll(".datepicker__input");
  if (datepickerInputs) {
    let datepickers = {};
    import("./datepicker/Datepicker.svelte").then(({ default: Datepicker }) => {
      let today = new Date();
      for (let index = 0; index < datepickerInputs.length; index++) {
        const element = datepickerInputs[index];
        if (element) {
          element.innerHTML = "";
        }
        let { dataset } = element;
        let {
          name,
          id,
          holidays,
          start,
          end,
          past,
          future,
          selected,
          tracking,
          fieldname,
          fieldkey,
          exceptionlist,
          valdate,
          val,
          valrequired,
          disablefocustracking
        } = dataset;
        element.innerHTML = "";
        datepickers[`${index}`] = mount(Datepicker, {
          target: element,
          props: {
            name: name ? name : "",
            id: id ? id : "",
            start:
              start ? new Date(start)
                : (future && future !== "false")
                  ? today
                  : new Date(1900, 9, 15),
            end:
              end ? new Date(end)
                : past && past !== "false"
                  ? today
                  : new Date(2030, 9, 15),
            selected:
              selected ? new Date(selected)
                : start ? new Date(start)
                  : new Date(),
            excludeHolidays: holidays && holidays === "true",
            defaultSelection: selected ? new Date(selected) : void 0,
            exceptionList: exceptionlist ? exceptionlist.split(",") : void 0,
            tracking,
            fieldName: fieldname,
            fieldKey: fieldkey,
            val,
            valdate,
            valrequired,
            disableFocusTracking: disablefocustracking && disablefocustracking === "true"
          },
        });
        app = {
          ...app,
          ...datepickers,
        };
      }
    });
  }
};
window.loadDatePickers();

